// extracted by mini-css-extract-plugin
module.exports = {"main":"css_main__3K5L5","navigation":"css_navigation__beXLW","memeContainer":"css_memeContainer__2Ga2U","meme":"css_meme__3zGtR","textOverlay":"css_textOverlay__1MFHn"};